import { gql } from '@apollo/client';
import { useEffect, useMemo, useState } from 'react';
import { MstOffice } from 'src/common/interfaces';
import { getMstOffice } from 'src/graphql/queries';
import { useAppLazyQuery } from 'src/libs/hooks';

const ModalGuideOffice = ({
  setIsOpen,
  onCallbackFunction,
}: {
  setIsOpen: (isOpen: boolean) => void;
  onCallbackFunction: (item: MstOffice) => void;
}) => {
  const header = ['拠点コード', '拠点名'];
  const [mstOffice, setMstOffice] = useState<Array<MstOffice>>([]);
  const [mstOfficeCd, setMstOfficeCd] = useState<string>('');
  const [mstOfficeMn, setMstOfficeMn] = useState<string>('');
  const [searchMstOffice, { data: mstOfficeData, loading: isMstOfficeLoading }] = useAppLazyQuery({
    query: gql(getMstOffice),
  });

  const renderTableHeader = () => {
    return header.map((key, index) => (
      <th
        className="whitespace-nowrap p-[8px] sticky top-0 border-[1px] border-solid border-[#ddd] pt-[12px] pb-[12px] text-center bg-blue-400 text-[#fff]"
        key={index}
      >
        {key.toUpperCase()}
      </th>
    ));
  };

  const onClickItemOffice = (office: MstOffice) => {
    onCallbackFunction(office);
    setIsOpen(false);
  };

  const renderTableData = useMemo(() => {
    if (mstOffice?.length <= 0 || !mstOffice) return;
    return mstOffice.map((office: MstOffice, index: number) => {
      return (
        <tr key={index}>
          <td className="p-[8px] border-[1px] border-solid border-[#ddd]">
            <p>{office?.mo_office_cd}</p>
          </td>
          <td className="p-[8px] border-[1px] border-solid border-[#ddd] text-blue-600 cursor-pointer">
            <p onClick={() => onClickItemOffice(office)}>{office?.mo_office_nm}</p>
          </td>
        </tr>
      );
    });
  }, [mstOffice]);

  const onPressSearch = () => {
    const params = {
      mo_office_cd: mstOfficeCd === '' ? null : mstOfficeCd,
      mo_office_nm: mstOfficeMn,
    };
    searchMstOffice({ variables: { input: params } });
  };

  useEffect(() => {
    const newMstOfficeData = { ...mstOfficeData };
    const listOffice: MstOffice[] =
      newMstOfficeData?.getMstOffice?.sort((office1: any, office2: any) => {
        return office1.mo_office_cd - office2.mo_office_cd;
      }) || [];
    setMstOffice(listOffice);
  }, [mstOfficeData]);

  return (
    <>
      <div className="bg-[#00000030] w-full h-full z-[0] inset-0 fixed" />
      <div className="flex fixed bg-white h-4/6 w-1/3 items-center flex-col z-[1] overflow-auto">
        <div className="w-5/6 flex justify-end items-center mt-[10px]">
          <button onClick={() => setIsOpen(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="h-[40px] w-4/5 flex justify-center items-center border border-zinc-300 mt-[50px]">
          <div className="h-full w-2/5 flex justify-center items-center bg-blue-400 text-white">拠点コード</div>
          <div className="h-full w-3/5 flex justify-center items-center">
            <input
              className="bg-transparent pl-[5px] h-[40px] w-full"
              onChange={(event) => {
                if (event.target.value.length > 8) return;
                setMstOfficeCd(event?.target?.value);
              }}
              type="number"
              name="mst_office_cd"
              value={mstOfficeCd}
              min={1}
            />
          </div>
        </div>
        <div className="h-[40px] w-4/5 flex justify-center items-center border border-zinc-300 mt-[10px]">
          <div className="h-full w-2/5 flex justify-center items-center bg-blue-400 text-white">拠点名</div>
          <div className="h-full w-3/5 flex justify-center items-center">
            <input
              className="bg-transparent pl-[5px] h-[40px] w-full"
              onChange={(event) => {
                if (event.target.value.length > 50) return;
                setMstOfficeMn(event?.target?.value);
              }}
              type="text"
              name="mst_office_nm"
              value={mstOfficeMn}
            />
          </div>
        </div>
        <div className="h-[40px] w-4/5	flex justify-end items-center mt-[10px] ">
          <button
            onClick={onPressSearch}
            className="border border-zinc-300 h-[40px] w-[100px] justify-center items-center flex"
          >
            <p>検索</p>
          </button>
        </div>
        <div className="overflow-auto max-h-100 w-4/5 mt-[20px] mb-[20px]">
          <table className="text-center border-collapse border-[3px] border-solid border-[#ddd] w-full td:p-[10px]  ">
            <thead>
              <tr>{renderTableHeader()}</tr>
            </thead>
            <tbody>
              {isMstOfficeLoading ? (
                <tr>
                  <td
                    colSpan={header.length}
                    className="text-center animate-pulse p-[8px] border-[1px] border-solid border-[#fff]"
                  >
                    Loading...
                  </td>
                </tr>
              ) : (
                renderTableData
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ModalGuideOffice;
